import * as React from 'react';
import { Context } from '@grandvisionhq/carts-v2';
import { useSelector, useDispatch } from '@grandvisionhq/state';
import { selectShippingMethod } from '../../StepShipping/actions.js';
import { getSelectedShippingMethod } from '../../StepShipping/selectors.js';

const useRestoreCartShippingMethod = ()=>{
    var ref2;
    const shippingMethod = useSelector(getSelectedShippingMethod);
    const { cart  } = Context.useCart();
    const dispatch = useDispatch();
    const restoreShippingMethod = React.useCallback(()=>{
        var ref;
        if ((shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.method) !== (cart === null || cart === void 0 ? void 0 : (ref = cart.shippingMethod) === null || ref === void 0 ? void 0 : ref.key)) {
            var ref1;
            dispatch(selectShippingMethod({
                shippingMethod: {
                    method: cart === null || cart === void 0 ? void 0 : (ref1 = cart.shippingMethod) === null || ref1 === void 0 ? void 0 : ref1.key,
                    isValid: true,
                    isTouched: true
                }
            }));
        }
    }, [
        shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.method,
        cart === null || cart === void 0 ? void 0 : (ref2 = cart.shippingMethod) === null || ref2 === void 0 ? void 0 : ref2.key,
        dispatch
    ]);
    return {
        restoreShippingMethod
    };
};

export { useRestoreCartShippingMethod };
//# sourceMappingURL=use-restore-cart-shipping-method.js.map
